import { FETCH_MUTUAL_CONNECTIONS, RESET_MUTUAL_CONNECTIONS, SHOW_MUTUAL_CONNECTIONS_MODAL } from './ActionTypes';

export const fetchMutualConnections = ({ displayName, reset }) => ({
    type: FETCH_MUTUAL_CONNECTIONS,
    displayName,
    reset
});

export const resetMutualConnections = () => ({
    type: RESET_MUTUAL_CONNECTIONS
});

export const showMutualConnectionsModal = (payload) => ({
    type: SHOW_MUTUAL_CONNECTIONS_MODAL,
    payload
});
